import { api } from '../../lib/api';
import type { AccountAnalyticsRoster, AccountCountHistory } from '../../types/accountAnalytics';

// The single Account Analytics fetch — the enriched roster + AM directory
// (admin-only). The client fetches this ONCE and does all filter / sort /
// paginate / aggregate locally (surveys/metaAds fetch-all pattern).
export async function getAccountAnalyticsRoster(): Promise<AccountAnalyticsRoster> {
  return api<AccountAnalyticsRoster>('/api/account-analytics/roster');
}

// The account-count history (Phase C) — the ordered monthly snapshot series +
// brand/group/AM label maps. Fetched only when the Business lens's "Account
// counts" metric is selected; the pivot builds the continuous-domain series.
export async function getAccountCountHistory(): Promise<AccountCountHistory> {
  return api<AccountCountHistory>('/api/account-analytics/count-history');
}
